import React, { useMemo } from 'react';
import { Card, Button } from 'react-bootstrap';
import { FaFileExcel } from 'react-icons/fa';
import TabelaDinamica from '~/Components/TabelaDinamica/Tabela';
import { exportarEmExcel } from '~/Utils/Helpers';

// W-0617 — Tabela de resultado do Mapeamento Geral Estoque.
// Fonte: UqrEstoque.dfm (rótulos confirmados gate-1a) — D=Disp, R=Reser, B=Bloq, V=Vend.,
// C=Cart., P=P.Vda., A=Alu., O=Cad.Rap. + coluna Valor (custo convertido — RN-3 placeholder 0).

const fmtMoeda = (valor) => {
  if (valor === null || valor === undefined) return '0,00';
  const n = Number(valor) || 0;
  return n.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const fmtInt = (valor) => {
  const n = Number(valor) || 0;
  return n.toLocaleString('pt-BR');
};

const colunas = [
  { title: 'Empresa', key: 'empresa', ordenacao: true, align: 'left' },
  { title: 'Empreendimento', key: 'empreendimento', ordenacao: true, align: 'left' },
  { title: 'Disp', key: 'qtd_d', ordenacao: true, align: 'right', render: fmtInt },
  { title: 'Reser', key: 'qtd_r', ordenacao: true, align: 'right', render: fmtInt },
  { title: 'Bloq', key: 'qtd_b', ordenacao: true, align: 'right', render: fmtInt },
  { title: 'Vend.', key: 'qtd_v', ordenacao: true, align: 'right', render: fmtInt },
  { title: 'Cart.', key: 'qtd_c', ordenacao: true, align: 'right', render: fmtInt },
  { title: 'P.Vda.', key: 'qtd_p', ordenacao: true, align: 'right', render: fmtInt },
  { title: 'Alu.', key: 'qtd_a', ordenacao: true, align: 'right', render: fmtInt },
  { title: 'Cad.Rap.', key: 'qtd_o', ordenacao: true, align: 'right', render: fmtInt },
  { title: 'Valor', key: 'valor', ordenacao: true, align: 'right', render: fmtMoeda },
];

// Ordem das colunas no CSV de exportação (espelha o grid).
const CABECALHO_EXCEL = [
  'Empresa',
  'Empreendimento',
  'Disp',
  'Reser',
  'Bloq',
  'Vend.',
  'Cart.',
  'P.Vda.',
  'Alu.',
  'Cad.Rap.',
  'Valor',
];

const ResultadoTabela = ({ resultado }) => {
  const linhas = useMemo(() => (resultado && resultado.linhas) || [], [resultado]);

  if (!resultado) return null;

  const handleExportar = () => {
    if (!linhas.length) return;
    const corpo = linhas.map((l) => [
      l.empresa,
      l.empreendimento,
      l.qtd_d,
      l.qtd_r,
      l.qtd_b,
      l.qtd_v,
      l.qtd_c,
      l.qtd_p,
      l.qtd_a,
      l.qtd_o,
      fmtMoeda(l.valor),
    ]);
    const totais = [
      'TOTAL',
      '',
      resultado.total_d,
      resultado.total_r,
      resultado.total_b,
      resultado.total_v,
      resultado.total_c,
      resultado.total_p,
      resultado.total_a,
      resultado.total_o,
      fmtMoeda(resultado.total_valor),
    ];
    exportarEmExcel(
      [CABECALHO_EXCEL, ...corpo, totais],
      'mapeamento-geral-estoque.csv'
    );
  };

  return (
    <Card className="mt-3">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <strong>
          Mapeamento Geral Estoque
          {resultado.nome_moeda
            ? ` — Moeda ${resultado.nome_moeda}`
            : ` — Moeda ${resultado.codigo_moeda}`}
        </strong>
        <Button
          variant="success"
          size="sm"
          onClick={handleExportar}
          disabled={linhas.length === 0}
          title="Exportar resultado para Excel"
        >
          <FaFileExcel className="mr-2" />
          Exportar Excel
        </Button>
      </Card.Header>
      <Card.Body>
        {linhas.length === 0 ? (
          <div className="alert alert-info mb-0">
            Nenhum registro encontrado para os grupos de empresa selecionados.
          </div>
        ) : (
          <>
            <div style={{ overflowX: 'auto' }}>
              <TabelaDinamica colunas={colunas} dados={linhas} />
            </div>
            <div
              style={{
                marginTop: '12px',
                padding: '10px 16px',
                backgroundColor: '#f1f5f9',
                borderRadius: '4px',
                fontSize: '0.9rem',
              }}
            >
              <strong>Totais:</strong> Disp {fmtInt(resultado.total_d)} | Reser{' '}
              {fmtInt(resultado.total_r)} | Bloq {fmtInt(resultado.total_b)} | Vend.{' '}
              {fmtInt(resultado.total_v)} | Cart. {fmtInt(resultado.total_c)} | P.Vda.{' '}
              {fmtInt(resultado.total_p)} | Alu. {fmtInt(resultado.total_a)} | Cad.Rap.{' '}
              {fmtInt(resultado.total_o)} | Valor R$ {fmtMoeda(resultado.total_valor)}
            </div>
            <small className="text-muted">
              {linhas.length} {linhas.length === 1 ? 'registro' : 'registros'}
            </small>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default ResultadoTabela;
